import { Package } from './';

export class Release {
    ReleaseNumber: number;
    ReleaseDate: Date;
    ReleaseNotes: string;
    Released: boolean;
    Packages: Package[];
    IsPublishAllowed: boolean = false;
}
